/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation } from "@aws-amplify/api";
import { GraphQLResult } from "@aws-amplify/api/lib/types";
import * as Observable from "zen-observable";

export type CreatePoiInput = {
  id?: string | null;
  position_lat: number;
  position_lng: number;
  position_flr: number;
  owner: string;
  organizationID: string;
  createdAt?: string | null;
  data?: string | null;
  status?: number | null;
  files?: Array<string | null> | null;
  icon?: string | null;
  shape: number;
  poiTypeId: string;
  poiLayerId: string;
  poiCityId: string;
  poiOrganizationId: string;
};

export type ModelPoiConditionInput = {
  position_lat?: ModelFloatInput | null;
  position_lng?: ModelFloatInput | null;
  position_flr?: ModelFloatInput | null;
  owner?: ModelStringInput | null;
  organizationID?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  data?: ModelStringInput | null;
  status?: ModelIntInput | null;
  files?: ModelStringInput | null;
  icon?: ModelStringInput | null;
  shape?: ModelIntInput | null;
  and?: Array<ModelPoiConditionInput | null> | null;
  or?: Array<ModelPoiConditionInput | null> | null;
  not?: ModelPoiConditionInput | null;
};

export type ModelFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type UpdatePoiInput = {
  id: string;
  position_lat?: number | null;
  position_lng?: number | null;
  position_flr?: number | null;
  owner?: string | null;
  organizationID?: string | null;
  createdAt?: string | null;
  data?: string | null;
  status?: number | null;
  files?: Array<string | null> | null;
  icon?: string | null;
  shape?: number | null;
  poiTypeId?: string | null;
  poiLayerId?: string | null;
  poiCityId?: string | null;
  poiOrganizationId?: string | null;
};

export type DeletePoiInput = {
  id?: string | null;
};

export type CreatePoiLayerInput = {
  id?: string | null;
  name?: string | null;
  color?: string | null;
  data?: string | null;
  owner: string;
  organizationID: string;
  status?: number | null;
  poiLayerCityId: string;
  poiLayerOrganizationId: string;
};

export type ModelPoiLayerConditionInput = {
  name?: ModelStringInput | null;
  color?: ModelStringInput | null;
  data?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  organizationID?: ModelStringInput | null;
  status?: ModelIntInput | null;
  and?: Array<ModelPoiLayerConditionInput | null> | null;
  or?: Array<ModelPoiLayerConditionInput | null> | null;
  not?: ModelPoiLayerConditionInput | null;
};

export type UpdatePoiLayerInput = {
  id: string;
  name?: string | null;
  color?: string | null;
  data?: string | null;
  owner?: string | null;
  organizationID?: string | null;
  status?: number | null;
  poiLayerCityId?: string | null;
  poiLayerOrganizationId?: string | null;
};

export type DeletePoiLayerInput = {
  id?: string | null;
};

export type CreatePoiTypeInput = {
  id?: string | null;
  name?: string | null;
  status?: number | null;
  structure?: string | null;
  icon?: string | null;
  infowindow?: string | null;
};

export type ModelPoiTypeConditionInput = {
  name?: ModelStringInput | null;
  status?: ModelIntInput | null;
  structure?: ModelStringInput | null;
  icon?: ModelStringInput | null;
  infowindow?: ModelStringInput | null;
  and?: Array<ModelPoiTypeConditionInput | null> | null;
  or?: Array<ModelPoiTypeConditionInput | null> | null;
  not?: ModelPoiTypeConditionInput | null;
};

export type UpdatePoiTypeInput = {
  id: string;
  name?: string | null;
  status?: number | null;
  structure?: string | null;
  icon?: string | null;
  infowindow?: string | null;
};

export type DeletePoiTypeInput = {
  id?: string | null;
};

export type CreateCitiesInput = {
  id?: string | null;
  organizationID: string;
  name: string;
  position_lat: number;
  position_lng: number;
  position_flr: number;
  area?: string | null;
  info?: string | null;
  citiesOrganizationId?: string | null;
};

export type ModelCitiesConditionInput = {
  organizationID?: ModelStringInput | null;
  name?: ModelStringInput | null;
  position_lat?: ModelFloatInput | null;
  position_lng?: ModelFloatInput | null;
  position_flr?: ModelFloatInput | null;
  area?: ModelStringInput | null;
  info?: ModelStringInput | null;
  and?: Array<ModelCitiesConditionInput | null> | null;
  or?: Array<ModelCitiesConditionInput | null> | null;
  not?: ModelCitiesConditionInput | null;
};

export type UpdateCitiesInput = {
  id: string;
  organizationID?: string | null;
  name?: string | null;
  position_lat?: number | null;
  position_lng?: number | null;
  position_flr?: number | null;
  area?: string | null;
  info?: string | null;
  citiesOrganizationId?: string | null;
};

export type DeleteCitiesInput = {
  id?: string | null;
};

export type CreateImportsInput = {
  id?: string | null;
  date: string;
  owner?: string | null;
  data?: string | null;
  schema?: string | null;
  importsCityId: string;
  importsLayerId: string;
  importsTypeId: string;
};

export type ModelImportsConditionInput = {
  date?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  data?: ModelStringInput | null;
  schema?: ModelStringInput | null;
  and?: Array<ModelImportsConditionInput | null> | null;
  or?: Array<ModelImportsConditionInput | null> | null;
  not?: ModelImportsConditionInput | null;
};

export type UpdateImportsInput = {
  id: string;
  date?: string | null;
  owner?: string | null;
  data?: string | null;
  schema?: string | null;
  importsCityId?: string | null;
  importsLayerId?: string | null;
  importsTypeId?: string | null;
};

export type DeleteImportsInput = {
  id?: string | null;
};

export type CreateOrganizationsInput = {
  id?: string | null;
  name: string;
  users?: Array<string | null> | null;
  info?: string | null;
  poiTypes?: Array<string | null> | null;
  organizationsPoiId?: string | null;
  organizationsPoilayersId?: string | null;
};

export type ModelOrganizationsConditionInput = {
  name?: ModelStringInput | null;
  users?: ModelStringInput | null;
  info?: ModelStringInput | null;
  poiTypes?: ModelStringInput | null;
  and?: Array<ModelOrganizationsConditionInput | null> | null;
  or?: Array<ModelOrganizationsConditionInput | null> | null;
  not?: ModelOrganizationsConditionInput | null;
};

export type UpdateOrganizationsInput = {
  id: string;
  name?: string | null;
  users?: Array<string | null> | null;
  info?: string | null;
  poiTypes?: Array<string | null> | null;
  organizationsPoiId?: string | null;
  organizationsPoilayersId?: string | null;
};

export type DeleteOrganizationsInput = {
  id?: string | null;
};

export type CreateExportsInput = {
  id?: string | null;
  date: string;
  organizationID: string;
  owner?: string | null;
  data?: string | null;
  fileuriCSV?: string | null;
  fileuriXLSX?: string | null;
};

export type ModelExportsConditionInput = {
  date?: ModelStringInput | null;
  organizationID?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  data?: ModelStringInput | null;
  fileuriCSV?: ModelStringInput | null;
  fileuriXLSX?: ModelStringInput | null;
  and?: Array<ModelExportsConditionInput | null> | null;
  or?: Array<ModelExportsConditionInput | null> | null;
  not?: ModelExportsConditionInput | null;
};

export type UpdateExportsInput = {
  id: string;
  date?: string | null;
  organizationID?: string | null;
  owner?: string | null;
  data?: string | null;
  fileuriCSV?: string | null;
  fileuriXLSX?: string | null;
};

export type DeleteExportsInput = {
  id?: string | null;
};

export type CreateFilesInput = {
  id?: string | null;
  date: string;
  organizationID: string;
  owner?: string | null;
  name?: string | null;
  type?: string | null;
  parent: string;
  s3path?: string | null;
};

export type ModelFilesConditionInput = {
  date?: ModelStringInput | null;
  organizationID?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  name?: ModelStringInput | null;
  type?: ModelStringInput | null;
  parent?: ModelStringInput | null;
  s3path?: ModelStringInput | null;
  and?: Array<ModelFilesConditionInput | null> | null;
  or?: Array<ModelFilesConditionInput | null> | null;
  not?: ModelFilesConditionInput | null;
};

export type UpdateFilesInput = {
  id: string;
  date?: string | null;
  organizationID?: string | null;
  owner?: string | null;
  name?: string | null;
  type?: string | null;
  parent?: string | null;
  s3path?: string | null;
};

export type DeleteFilesInput = {
  id?: string | null;
};

export type CreatePoiMaintenancesInput = {
  id?: string | null;
  type: number;
  description?: string | null;
  info?: string | null;
  user_create: string;
  date_create: string;
  user_assigned: string;
  date_assigned: string;
  poiMaintenancesPoiId: string;
};

export type ModelPoiMaintenancesConditionInput = {
  type?: ModelIntInput | null;
  description?: ModelStringInput | null;
  info?: ModelStringInput | null;
  user_create?: ModelStringInput | null;
  date_create?: ModelStringInput | null;
  user_assigned?: ModelStringInput | null;
  date_assigned?: ModelStringInput | null;
  and?: Array<ModelPoiMaintenancesConditionInput | null> | null;
  or?: Array<ModelPoiMaintenancesConditionInput | null> | null;
  not?: ModelPoiMaintenancesConditionInput | null;
};

export type UpdatePoiMaintenancesInput = {
  id: string;
  type?: number | null;
  description?: string | null;
  info?: string | null;
  user_create?: string | null;
  date_create?: string | null;
  user_assigned?: string | null;
  date_assigned?: string | null;
  poiMaintenancesPoiId?: string | null;
};

export type DeletePoiMaintenancesInput = {
  id?: string | null;
};

export type CreatePoiMaintenancesActionsInput = {
  id?: string | null;
  type: number;
  status: number;
  description?: string | null;
  info?: string | null;
  user: string;
  date: string;
  poiMaintenancesActionsMaintenanceId?: string | null;
};

export type ModelPoiMaintenancesActionsConditionInput = {
  type?: ModelIntInput | null;
  status?: ModelIntInput | null;
  description?: ModelStringInput | null;
  info?: ModelStringInput | null;
  user?: ModelStringInput | null;
  date?: ModelStringInput | null;
  and?: Array<ModelPoiMaintenancesActionsConditionInput | null> | null;
  or?: Array<ModelPoiMaintenancesActionsConditionInput | null> | null;
  not?: ModelPoiMaintenancesActionsConditionInput | null;
};

export type UpdatePoiMaintenancesActionsInput = {
  id: string;
  type?: number | null;
  status?: number | null;
  description?: string | null;
  info?: string | null;
  user?: string | null;
  date?: string | null;
  poiMaintenancesActionsMaintenanceId?: string | null;
};

export type DeletePoiMaintenancesActionsInput = {
  id?: string | null;
};

export type ModelPoiFilterInput = {
  id?: ModelIDInput | null;
  position_lat?: ModelFloatInput | null;
  position_lng?: ModelFloatInput | null;
  position_flr?: ModelFloatInput | null;
  owner?: ModelStringInput | null;
  organizationID?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  data?: ModelStringInput | null;
  status?: ModelIntInput | null;
  files?: ModelStringInput | null;
  icon?: ModelStringInput | null;
  shape?: ModelIntInput | null;
  and?: Array<ModelPoiFilterInput | null> | null;
  or?: Array<ModelPoiFilterInput | null> | null;
  not?: ModelPoiFilterInput | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type ModelPoiLayerFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  color?: ModelStringInput | null;
  data?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  organizationID?: ModelStringInput | null;
  status?: ModelIntInput | null;
  and?: Array<ModelPoiLayerFilterInput | null> | null;
  or?: Array<ModelPoiLayerFilterInput | null> | null;
  not?: ModelPoiLayerFilterInput | null;
};

export type ModelPoiTypeFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  status?: ModelIntInput | null;
  structure?: ModelStringInput | null;
  icon?: ModelStringInput | null;
  infowindow?: ModelStringInput | null;
  and?: Array<ModelPoiTypeFilterInput | null> | null;
  or?: Array<ModelPoiTypeFilterInput | null> | null;
  not?: ModelPoiTypeFilterInput | null;
};

export type ModelCitiesFilterInput = {
  id?: ModelIDInput | null;
  organizationID?: ModelStringInput | null;
  name?: ModelStringInput | null;
  position_lat?: ModelFloatInput | null;
  position_lng?: ModelFloatInput | null;
  position_flr?: ModelFloatInput | null;
  area?: ModelStringInput | null;
  info?: ModelStringInput | null;
  and?: Array<ModelCitiesFilterInput | null> | null;
  or?: Array<ModelCitiesFilterInput | null> | null;
  not?: ModelCitiesFilterInput | null;
};

export type ModelImportsFilterInput = {
  id?: ModelIDInput | null;
  date?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  data?: ModelStringInput | null;
  schema?: ModelStringInput | null;
  and?: Array<ModelImportsFilterInput | null> | null;
  or?: Array<ModelImportsFilterInput | null> | null;
  not?: ModelImportsFilterInput | null;
};

export type ModelOrganizationsFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  users?: ModelStringInput | null;
  info?: ModelStringInput | null;
  poiTypes?: ModelStringInput | null;
  and?: Array<ModelOrganizationsFilterInput | null> | null;
  or?: Array<ModelOrganizationsFilterInput | null> | null;
  not?: ModelOrganizationsFilterInput | null;
};

export type ModelExportsFilterInput = {
  id?: ModelIDInput | null;
  date?: ModelStringInput | null;
  organizationID?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  data?: ModelStringInput | null;
  fileuriCSV?: ModelStringInput | null;
  fileuriXLSX?: ModelStringInput | null;
  and?: Array<ModelExportsFilterInput | null> | null;
  or?: Array<ModelExportsFilterInput | null> | null;
  not?: ModelExportsFilterInput | null;
};

export type ModelFilesFilterInput = {
  id?: ModelIDInput | null;
  date?: ModelStringInput | null;
  organizationID?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  name?: ModelStringInput | null;
  type?: ModelStringInput | null;
  parent?: ModelStringInput | null;
  s3path?: ModelStringInput | null;
  and?: Array<ModelFilesFilterInput | null> | null;
  or?: Array<ModelFilesFilterInput | null> | null;
  not?: ModelFilesFilterInput | null;
};

export type ModelPoiMaintenancesFilterInput = {
  id?: ModelIDInput | null;
  type?: ModelIntInput | null;
  description?: ModelStringInput | null;
  info?: ModelStringInput | null;
  user_create?: ModelStringInput | null;
  date_create?: ModelStringInput | null;
  user_assigned?: ModelStringInput | null;
  date_assigned?: ModelStringInput | null;
  and?: Array<ModelPoiMaintenancesFilterInput | null> | null;
  or?: Array<ModelPoiMaintenancesFilterInput | null> | null;
  not?: ModelPoiMaintenancesFilterInput | null;
};

export type ModelPoiMaintenancesActionsFilterInput = {
  id?: ModelIDInput | null;
  type?: ModelIntInput | null;
  status?: ModelIntInput | null;
  description?: ModelStringInput | null;
  info?: ModelStringInput | null;
  user?: ModelStringInput | null;
  date?: ModelStringInput | null;
  and?: Array<ModelPoiMaintenancesActionsFilterInput | null> | null;
  or?: Array<ModelPoiMaintenancesActionsFilterInput | null> | null;
  not?: ModelPoiMaintenancesActionsFilterInput | null;
};

export type SearchablePoiFilterInput = {
  id?: SearchableIDFilterInput | null;
  position_lat?: SearchableFloatFilterInput | null;
  position_lng?: SearchableFloatFilterInput | null;
  position_flr?: SearchableFloatFilterInput | null;
  owner?: SearchableStringFilterInput | null;
  organizationID?: SearchableStringFilterInput | null;
  createdAt?: SearchableStringFilterInput | null;
  data?: SearchableStringFilterInput | null;
  status?: SearchableIntFilterInput | null;
  files?: SearchableStringFilterInput | null;
  icon?: SearchableStringFilterInput | null;
  shape?: SearchableIntFilterInput | null;
  and?: Array<SearchablePoiFilterInput | null> | null;
  or?: Array<SearchablePoiFilterInput | null> | null;
  not?: SearchablePoiFilterInput | null;
};

export type SearchableIDFilterInput = {
  ne?: string | null;
  gt?: string | null;
  lt?: string | null;
  gte?: string | null;
  lte?: string | null;
  eq?: string | null;
  match?: string | null;
  matchPhrase?: string | null;
  matchPhrasePrefix?: string | null;
  multiMatch?: string | null;
  exists?: boolean | null;
  wildcard?: string | null;
  regexp?: string | null;
};

export type SearchableFloatFilterInput = {
  ne?: number | null;
  gt?: number | null;
  lt?: number | null;
  gte?: number | null;
  lte?: number | null;
  eq?: number | null;
  range?: Array<number | null> | null;
};

export type SearchableStringFilterInput = {
  ne?: string | null;
  gt?: string | null;
  lt?: string | null;
  gte?: string | null;
  lte?: string | null;
  eq?: string | null;
  match?: string | null;
  matchPhrase?: string | null;
  matchPhrasePrefix?: string | null;
  multiMatch?: string | null;
  exists?: boolean | null;
  wildcard?: string | null;
  regexp?: string | null;
};

export type SearchableIntFilterInput = {
  ne?: number | null;
  gt?: number | null;
  lt?: number | null;
  gte?: number | null;
  lte?: number | null;
  eq?: number | null;
  range?: Array<number | null> | null;
};

export type SearchablePoiSortInput = {
  field?: SearchablePoiSortableFields | null;
  direction?: SearchableSortDirection | null;
};

export enum SearchablePoiSortableFields {
  id = "id",
  position_lat = "position_lat",
  position_lng = "position_lng",
  position_flr = "position_flr",
  owner = "owner",
  organizationID = "organizationID",
  createdAt = "createdAt",
  data = "data",
  status = "status",
  files = "files",
  icon = "icon",
  shape = "shape"
}

export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc"
}

export type SearchableCitiesFilterInput = {
  id?: SearchableIDFilterInput | null;
  organizationID?: SearchableStringFilterInput | null;
  name?: SearchableStringFilterInput | null;
  position_lat?: SearchableFloatFilterInput | null;
  position_lng?: SearchableFloatFilterInput | null;
  position_flr?: SearchableFloatFilterInput | null;
  area?: SearchableStringFilterInput | null;
  info?: SearchableStringFilterInput | null;
  and?: Array<SearchableCitiesFilterInput | null> | null;
  or?: Array<SearchableCitiesFilterInput | null> | null;
  not?: SearchableCitiesFilterInput | null;
};

export type SearchableCitiesSortInput = {
  field?: SearchableCitiesSortableFields | null;
  direction?: SearchableSortDirection | null;
};

export enum SearchableCitiesSortableFields {
  id = "id",
  organizationID = "organizationID",
  name = "name",
  position_lat = "position_lat",
  position_lng = "position_lng",
  position_flr = "position_flr",
  area = "area",
  info = "info"
}

export type SearchableFilesFilterInput = {
  id?: SearchableIDFilterInput | null;
  date?: SearchableStringFilterInput | null;
  organizationID?: SearchableStringFilterInput | null;
  owner?: SearchableStringFilterInput | null;
  name?: SearchableStringFilterInput | null;
  type?: SearchableStringFilterInput | null;
  parent?: SearchableStringFilterInput | null;
  s3path?: SearchableStringFilterInput | null;
  and?: Array<SearchableFilesFilterInput | null> | null;
  or?: Array<SearchableFilesFilterInput | null> | null;
  not?: SearchableFilesFilterInput | null;
};

export type SearchableFilesSortInput = {
  field?: SearchableFilesSortableFields | null;
  direction?: SearchableSortDirection | null;
};

export enum SearchableFilesSortableFields {
  id = "id",
  date = "date",
  organizationID = "organizationID",
  owner = "owner",
  name = "name",
  type = "type",
  parent = "parent",
  s3path = "s3path"
}

export type CreatePoiMutation = {
  __typename: "Poi";
  id: string;
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  position_lat: number;
  position_lng: number;
  position_flr: number;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  createdAt: string | null;
  data: string | null;
  status: number | null;
  files: Array<string | null> | null;
  icon: string | null;
  shape: number;
  maintenances: {
    __typename: "ModelPoiMaintenancesConnection";
    items: Array<{
      __typename: "PoiMaintenances";
      id: string;
      type: number;
      description: string | null;
      info: string | null;
      user_create: string;
      date_create: string;
      user_assigned: string;
      date_assigned: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type UpdatePoiMutation = {
  __typename: "Poi";
  id: string;
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  position_lat: number;
  position_lng: number;
  position_flr: number;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  createdAt: string | null;
  data: string | null;
  status: number | null;
  files: Array<string | null> | null;
  icon: string | null;
  shape: number;
  maintenances: {
    __typename: "ModelPoiMaintenancesConnection";
    items: Array<{
      __typename: "PoiMaintenances";
      id: string;
      type: number;
      description: string | null;
      info: string | null;
      user_create: string;
      date_create: string;
      user_assigned: string;
      date_assigned: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type DeletePoiMutation = {
  __typename: "Poi";
  id: string;
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  position_lat: number;
  position_lng: number;
  position_flr: number;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  createdAt: string | null;
  data: string | null;
  status: number | null;
  files: Array<string | null> | null;
  icon: string | null;
  shape: number;
  maintenances: {
    __typename: "ModelPoiMaintenancesConnection";
    items: Array<{
      __typename: "PoiMaintenances";
      id: string;
      type: number;
      description: string | null;
      info: string | null;
      user_create: string;
      date_create: string;
      user_assigned: string;
      date_assigned: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type CreatePoiLayerMutation = {
  __typename: "PoiLayer";
  id: string;
  name: string | null;
  color: string | null;
  data: string | null;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  status: number | null;
};

export type UpdatePoiLayerMutation = {
  __typename: "PoiLayer";
  id: string;
  name: string | null;
  color: string | null;
  data: string | null;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  status: number | null;
};

export type DeletePoiLayerMutation = {
  __typename: "PoiLayer";
  id: string;
  name: string | null;
  color: string | null;
  data: string | null;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  status: number | null;
};

export type CreatePoiTypeMutation = {
  __typename: "PoiType";
  id: string;
  name: string | null;
  status: number | null;
  structure: string | null;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  icon: string | null;
  infowindow: string | null;
};

export type UpdatePoiTypeMutation = {
  __typename: "PoiType";
  id: string;
  name: string | null;
  status: number | null;
  structure: string | null;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  icon: string | null;
  infowindow: string | null;
};

export type DeletePoiTypeMutation = {
  __typename: "PoiType";
  id: string;
  name: string | null;
  status: number | null;
  structure: string | null;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  icon: string | null;
  infowindow: string | null;
};

export type CreateCitiesMutation = {
  __typename: "Cities";
  id: string;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  layers: {
    __typename: "ModelPoiLayerConnection";
    items: Array<{
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  } | null;
  organizationID: string;
  name: string;
  position_lat: number;
  position_lng: number;
  position_flr: number;
  area: string | null;
  info: string | null;
};

export type UpdateCitiesMutation = {
  __typename: "Cities";
  id: string;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  layers: {
    __typename: "ModelPoiLayerConnection";
    items: Array<{
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  } | null;
  organizationID: string;
  name: string;
  position_lat: number;
  position_lng: number;
  position_flr: number;
  area: string | null;
  info: string | null;
};

export type DeleteCitiesMutation = {
  __typename: "Cities";
  id: string;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  layers: {
    __typename: "ModelPoiLayerConnection";
    items: Array<{
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  } | null;
  organizationID: string;
  name: string;
  position_lat: number;
  position_lng: number;
  position_flr: number;
  area: string | null;
  info: string | null;
};

export type CreateImportsMutation = {
  __typename: "Imports";
  id: string;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  date: string;
  owner: string | null;
  data: string | null;
  schema: string | null;
};

export type UpdateImportsMutation = {
  __typename: "Imports";
  id: string;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  date: string;
  owner: string | null;
  data: string | null;
  schema: string | null;
};

export type DeleteImportsMutation = {
  __typename: "Imports";
  id: string;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  date: string;
  owner: string | null;
  data: string | null;
  schema: string | null;
};

export type CreateOrganizationsMutation = {
  __typename: "Organizations";
  id: string;
  cities: {
    __typename: "ModelCitiesConnection";
    items: Array<{
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  } | null;
  poilayers: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  } | null;
  name: string;
  users: Array<string | null> | null;
  info: string | null;
  poiTypes: Array<string | null> | null;
};

export type UpdateOrganizationsMutation = {
  __typename: "Organizations";
  id: string;
  cities: {
    __typename: "ModelCitiesConnection";
    items: Array<{
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  } | null;
  poilayers: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  } | null;
  name: string;
  users: Array<string | null> | null;
  info: string | null;
  poiTypes: Array<string | null> | null;
};

export type DeleteOrganizationsMutation = {
  __typename: "Organizations";
  id: string;
  cities: {
    __typename: "ModelCitiesConnection";
    items: Array<{
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  } | null;
  poilayers: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  } | null;
  name: string;
  users: Array<string | null> | null;
  info: string | null;
  poiTypes: Array<string | null> | null;
};

export type CreateExportsMutation = {
  __typename: "Exports";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  data: string | null;
  fileuriCSV: string | null;
  fileuriXLSX: string | null;
};

export type UpdateExportsMutation = {
  __typename: "Exports";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  data: string | null;
  fileuriCSV: string | null;
  fileuriXLSX: string | null;
};

export type DeleteExportsMutation = {
  __typename: "Exports";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  data: string | null;
  fileuriCSV: string | null;
  fileuriXLSX: string | null;
};

export type CreateFilesMutation = {
  __typename: "Files";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  name: string | null;
  type: string | null;
  parent: string;
  s3path: string | null;
};

export type UpdateFilesMutation = {
  __typename: "Files";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  name: string | null;
  type: string | null;
  parent: string;
  s3path: string | null;
};

export type DeleteFilesMutation = {
  __typename: "Files";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  name: string | null;
  type: string | null;
  parent: string;
  s3path: string | null;
};

export type CreatePoiMaintenancesMutation = {
  __typename: "PoiMaintenances";
  id: string;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  };
  type: number;
  description: string | null;
  info: string | null;
  user_create: string;
  date_create: string;
  user_assigned: string;
  date_assigned: string;
  maintenanceactions: {
    __typename: "ModelPoiMaintenancesActionsConnection";
    items: Array<{
      __typename: "PoiMaintenancesActions";
      id: string;
      type: number;
      status: number;
      description: string | null;
      info: string | null;
      user: string;
      date: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type UpdatePoiMaintenancesMutation = {
  __typename: "PoiMaintenances";
  id: string;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  };
  type: number;
  description: string | null;
  info: string | null;
  user_create: string;
  date_create: string;
  user_assigned: string;
  date_assigned: string;
  maintenanceactions: {
    __typename: "ModelPoiMaintenancesActionsConnection";
    items: Array<{
      __typename: "PoiMaintenancesActions";
      id: string;
      type: number;
      status: number;
      description: string | null;
      info: string | null;
      user: string;
      date: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type DeletePoiMaintenancesMutation = {
  __typename: "PoiMaintenances";
  id: string;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  };
  type: number;
  description: string | null;
  info: string | null;
  user_create: string;
  date_create: string;
  user_assigned: string;
  date_assigned: string;
  maintenanceactions: {
    __typename: "ModelPoiMaintenancesActionsConnection";
    items: Array<{
      __typename: "PoiMaintenancesActions";
      id: string;
      type: number;
      status: number;
      description: string | null;
      info: string | null;
      user: string;
      date: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type CreatePoiMaintenancesActionsMutation = {
  __typename: "PoiMaintenancesActions";
  id: string;
  type: number;
  status: number;
  maintenance: {
    __typename: "PoiMaintenances";
    id: string;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    };
    type: number;
    description: string | null;
    info: string | null;
    user_create: string;
    date_create: string;
    user_assigned: string;
    date_assigned: string;
    maintenanceactions: {
      __typename: "ModelPoiMaintenancesActionsConnection";
      nextToken: string | null;
    } | null;
  } | null;
  description: string | null;
  info: string | null;
  user: string;
  date: string;
};

export type UpdatePoiMaintenancesActionsMutation = {
  __typename: "PoiMaintenancesActions";
  id: string;
  type: number;
  status: number;
  maintenance: {
    __typename: "PoiMaintenances";
    id: string;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    };
    type: number;
    description: string | null;
    info: string | null;
    user_create: string;
    date_create: string;
    user_assigned: string;
    date_assigned: string;
    maintenanceactions: {
      __typename: "ModelPoiMaintenancesActionsConnection";
      nextToken: string | null;
    } | null;
  } | null;
  description: string | null;
  info: string | null;
  user: string;
  date: string;
};

export type DeletePoiMaintenancesActionsMutation = {
  __typename: "PoiMaintenancesActions";
  id: string;
  type: number;
  status: number;
  maintenance: {
    __typename: "PoiMaintenances";
    id: string;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    };
    type: number;
    description: string | null;
    info: string | null;
    user_create: string;
    date_create: string;
    user_assigned: string;
    date_assigned: string;
    maintenanceactions: {
      __typename: "ModelPoiMaintenancesActionsConnection";
      nextToken: string | null;
    } | null;
  } | null;
  description: string | null;
  info: string | null;
  user: string;
  date: string;
};

export type GetPoiQuery = {
  __typename: "Poi";
  id: string;
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  position_lat: number;
  position_lng: number;
  position_flr: number;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  createdAt: string | null;
  data: string | null;
  status: number | null;
  files: Array<string | null> | null;
  icon: string | null;
  shape: number;
  maintenances: {
    __typename: "ModelPoiMaintenancesConnection";
    items: Array<{
      __typename: "PoiMaintenances";
      id: string;
      type: number;
      description: string | null;
      info: string | null;
      user_create: string;
      date_create: string;
      user_assigned: string;
      date_assigned: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type ListPoisQuery = {
  __typename: "ModelPoiConnection";
  items: Array<{
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  } | null> | null;
  nextToken: string | null;
};

export type GetPoiLayerQuery = {
  __typename: "PoiLayer";
  id: string;
  name: string | null;
  color: string | null;
  data: string | null;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  status: number | null;
};

export type ListPoiLayersQuery = {
  __typename: "ModelPoiLayerConnection";
  items: Array<{
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  } | null> | null;
  nextToken: string | null;
};

export type GetPoiTypeQuery = {
  __typename: "PoiType";
  id: string;
  name: string | null;
  status: number | null;
  structure: string | null;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  icon: string | null;
  infowindow: string | null;
};

export type ListPoiTypesQuery = {
  __typename: "ModelPoiTypeConnection";
  items: Array<{
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  } | null> | null;
  nextToken: string | null;
};

export type GetCitiesQuery = {
  __typename: "Cities";
  id: string;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  layers: {
    __typename: "ModelPoiLayerConnection";
    items: Array<{
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  } | null;
  organizationID: string;
  name: string;
  position_lat: number;
  position_lng: number;
  position_flr: number;
  area: string | null;
  info: string | null;
};

export type ListCitiessQuery = {
  __typename: "ModelCitiesConnection";
  items: Array<{
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  } | null> | null;
  nextToken: string | null;
};

export type GetImportsQuery = {
  __typename: "Imports";
  id: string;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  date: string;
  owner: string | null;
  data: string | null;
  schema: string | null;
};

export type ListImportssQuery = {
  __typename: "ModelImportsConnection";
  items: Array<{
    __typename: "Imports";
    id: string;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    date: string;
    owner: string | null;
    data: string | null;
    schema: string | null;
  } | null> | null;
  nextToken: string | null;
};

export type GetOrganizationsQuery = {
  __typename: "Organizations";
  id: string;
  cities: {
    __typename: "ModelCitiesConnection";
    items: Array<{
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  } | null;
  poilayers: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  } | null;
  name: string;
  users: Array<string | null> | null;
  info: string | null;
  poiTypes: Array<string | null> | null;
};

export type ListOrganizationssQuery = {
  __typename: "ModelOrganizationsConnection";
  items: Array<{
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  } | null> | null;
  nextToken: string | null;
};

export type GetExportsQuery = {
  __typename: "Exports";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  data: string | null;
  fileuriCSV: string | null;
  fileuriXLSX: string | null;
};

export type ListExportssQuery = {
  __typename: "ModelExportsConnection";
  items: Array<{
    __typename: "Exports";
    id: string;
    date: string;
    organizationID: string;
    owner: string | null;
    data: string | null;
    fileuriCSV: string | null;
    fileuriXLSX: string | null;
  } | null> | null;
  nextToken: string | null;
};

export type GetFilesQuery = {
  __typename: "Files";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  name: string | null;
  type: string | null;
  parent: string;
  s3path: string | null;
};

export type ListFilessQuery = {
  __typename: "ModelFilesConnection";
  items: Array<{
    __typename: "Files";
    id: string;
    date: string;
    organizationID: string;
    owner: string | null;
    name: string | null;
    type: string | null;
    parent: string;
    s3path: string | null;
  } | null> | null;
  nextToken: string | null;
};

export type GetPoiMaintenancesQuery = {
  __typename: "PoiMaintenances";
  id: string;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  };
  type: number;
  description: string | null;
  info: string | null;
  user_create: string;
  date_create: string;
  user_assigned: string;
  date_assigned: string;
  maintenanceactions: {
    __typename: "ModelPoiMaintenancesActionsConnection";
    items: Array<{
      __typename: "PoiMaintenancesActions";
      id: string;
      type: number;
      status: number;
      description: string | null;
      info: string | null;
      user: string;
      date: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type ListPoiMaintenancessQuery = {
  __typename: "ModelPoiMaintenancesConnection";
  items: Array<{
    __typename: "PoiMaintenances";
    id: string;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    };
    type: number;
    description: string | null;
    info: string | null;
    user_create: string;
    date_create: string;
    user_assigned: string;
    date_assigned: string;
    maintenanceactions: {
      __typename: "ModelPoiMaintenancesActionsConnection";
      nextToken: string | null;
    } | null;
  } | null> | null;
  nextToken: string | null;
};

export type GetPoiMaintenancesActionsQuery = {
  __typename: "PoiMaintenancesActions";
  id: string;
  type: number;
  status: number;
  maintenance: {
    __typename: "PoiMaintenances";
    id: string;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    };
    type: number;
    description: string | null;
    info: string | null;
    user_create: string;
    date_create: string;
    user_assigned: string;
    date_assigned: string;
    maintenanceactions: {
      __typename: "ModelPoiMaintenancesActionsConnection";
      nextToken: string | null;
    } | null;
  } | null;
  description: string | null;
  info: string | null;
  user: string;
  date: string;
};

export type ListPoiMaintenancesActionssQuery = {
  __typename: "ModelPoiMaintenancesActionsConnection";
  items: Array<{
    __typename: "PoiMaintenancesActions";
    id: string;
    type: number;
    status: number;
    maintenance: {
      __typename: "PoiMaintenances";
      id: string;
      type: number;
      description: string | null;
      info: string | null;
      user_create: string;
      date_create: string;
      user_assigned: string;
      date_assigned: string;
    } | null;
    description: string | null;
    info: string | null;
    user: string;
    date: string;
  } | null> | null;
  nextToken: string | null;
};

export type SearchPoisQuery = {
  __typename: "SearchablePoiConnection";
  items: Array<{
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  } | null> | null;
  nextToken: string | null;
  total: number | null;
};

export type SearchCitiessQuery = {
  __typename: "SearchableCitiesConnection";
  items: Array<{
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  } | null> | null;
  nextToken: string | null;
  total: number | null;
};

export type SearchFilessQuery = {
  __typename: "SearchableFilesConnection";
  items: Array<{
    __typename: "Files";
    id: string;
    date: string;
    organizationID: string;
    owner: string | null;
    name: string | null;
    type: string | null;
    parent: string;
    s3path: string | null;
  } | null> | null;
  nextToken: string | null;
  total: number | null;
};

export type OnCreatePoiSubscription = {
  __typename: "Poi";
  id: string;
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  position_lat: number;
  position_lng: number;
  position_flr: number;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  createdAt: string | null;
  data: string | null;
  status: number | null;
  files: Array<string | null> | null;
  icon: string | null;
  shape: number;
  maintenances: {
    __typename: "ModelPoiMaintenancesConnection";
    items: Array<{
      __typename: "PoiMaintenances";
      id: string;
      type: number;
      description: string | null;
      info: string | null;
      user_create: string;
      date_create: string;
      user_assigned: string;
      date_assigned: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type OnUpdatePoiSubscription = {
  __typename: "Poi";
  id: string;
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  position_lat: number;
  position_lng: number;
  position_flr: number;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  createdAt: string | null;
  data: string | null;
  status: number | null;
  files: Array<string | null> | null;
  icon: string | null;
  shape: number;
  maintenances: {
    __typename: "ModelPoiMaintenancesConnection";
    items: Array<{
      __typename: "PoiMaintenances";
      id: string;
      type: number;
      description: string | null;
      info: string | null;
      user_create: string;
      date_create: string;
      user_assigned: string;
      date_assigned: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type OnDeletePoiSubscription = {
  __typename: "Poi";
  id: string;
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  position_lat: number;
  position_lng: number;
  position_flr: number;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  createdAt: string | null;
  data: string | null;
  status: number | null;
  files: Array<string | null> | null;
  icon: string | null;
  shape: number;
  maintenances: {
    __typename: "ModelPoiMaintenancesConnection";
    items: Array<{
      __typename: "PoiMaintenances";
      id: string;
      type: number;
      description: string | null;
      info: string | null;
      user_create: string;
      date_create: string;
      user_assigned: string;
      date_assigned: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type OnCreatePoiLayerSubscription = {
  __typename: "PoiLayer";
  id: string;
  name: string | null;
  color: string | null;
  data: string | null;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  status: number | null;
};

export type OnUpdatePoiLayerSubscription = {
  __typename: "PoiLayer";
  id: string;
  name: string | null;
  color: string | null;
  data: string | null;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  status: number | null;
};

export type OnDeletePoiLayerSubscription = {
  __typename: "PoiLayer";
  id: string;
  name: string | null;
  color: string | null;
  data: string | null;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  owner: string;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  };
  organizationID: string;
  status: number | null;
};

export type OnCreatePoiTypeSubscription = {
  __typename: "PoiType";
  id: string;
  name: string | null;
  status: number | null;
  structure: string | null;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  icon: string | null;
  infowindow: string | null;
};

export type OnUpdatePoiTypeSubscription = {
  __typename: "PoiType";
  id: string;
  name: string | null;
  status: number | null;
  structure: string | null;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  icon: string | null;
  infowindow: string | null;
};

export type OnDeletePoiTypeSubscription = {
  __typename: "PoiType";
  id: string;
  name: string | null;
  status: number | null;
  structure: string | null;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  icon: string | null;
  infowindow: string | null;
};

export type OnCreateCitiesSubscription = {
  __typename: "Cities";
  id: string;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  layers: {
    __typename: "ModelPoiLayerConnection";
    items: Array<{
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  } | null;
  organizationID: string;
  name: string;
  position_lat: number;
  position_lng: number;
  position_flr: number;
  area: string | null;
  info: string | null;
};

export type OnUpdateCitiesSubscription = {
  __typename: "Cities";
  id: string;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  layers: {
    __typename: "ModelPoiLayerConnection";
    items: Array<{
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  } | null;
  organizationID: string;
  name: string;
  position_lat: number;
  position_lng: number;
  position_flr: number;
  area: string | null;
  info: string | null;
};

export type OnDeleteCitiesSubscription = {
  __typename: "Cities";
  id: string;
  poi: {
    __typename: "ModelPoiConnection";
    items: Array<{
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null> | null;
    nextToken: string | null;
  } | null;
  layers: {
    __typename: "ModelPoiLayerConnection";
    items: Array<{
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  imports: {
    __typename: "ModelImportsConnection";
    items: Array<{
      __typename: "Imports";
      id: string;
      date: string;
      owner: string | null;
      data: string | null;
      schema: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  organization: {
    __typename: "Organizations";
    id: string;
    cities: {
      __typename: "ModelCitiesConnection";
      nextToken: string | null;
    } | null;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    } | null;
    poilayers: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    } | null;
    name: string;
    users: Array<string | null> | null;
    info: string | null;
    poiTypes: Array<string | null> | null;
  } | null;
  organizationID: string;
  name: string;
  position_lat: number;
  position_lng: number;
  position_flr: number;
  area: string | null;
  info: string | null;
};

export type OnCreateImportsSubscription = {
  __typename: "Imports";
  id: string;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  date: string;
  owner: string | null;
  data: string | null;
  schema: string | null;
};

export type OnUpdateImportsSubscription = {
  __typename: "Imports";
  id: string;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  date: string;
  owner: string | null;
  data: string | null;
  schema: string | null;
};

export type OnDeleteImportsSubscription = {
  __typename: "Imports";
  id: string;
  city: {
    __typename: "Cities";
    id: string;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    layers: {
      __typename: "ModelPoiLayerConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    } | null;
    organizationID: string;
    name: string;
    position_lat: number;
    position_lng: number;
    position_flr: number;
    area: string | null;
    info: string | null;
  };
  layer: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  };
  type: {
    __typename: "PoiType";
    id: string;
    name: string | null;
    status: number | null;
    structure: string | null;
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    icon: string | null;
    infowindow: string | null;
  };
  date: string;
  owner: string | null;
  data: string | null;
  schema: string | null;
};

export type OnCreateOrganizationsSubscription = {
  __typename: "Organizations";
  id: string;
  cities: {
    __typename: "ModelCitiesConnection";
    items: Array<{
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  } | null;
  poilayers: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  } | null;
  name: string;
  users: Array<string | null> | null;
  info: string | null;
  poiTypes: Array<string | null> | null;
};

export type OnUpdateOrganizationsSubscription = {
  __typename: "Organizations";
  id: string;
  cities: {
    __typename: "ModelCitiesConnection";
    items: Array<{
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  } | null;
  poilayers: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  } | null;
  name: string;
  users: Array<string | null> | null;
  info: string | null;
  poiTypes: Array<string | null> | null;
};

export type OnDeleteOrganizationsSubscription = {
  __typename: "Organizations";
  id: string;
  cities: {
    __typename: "ModelCitiesConnection";
    items: Array<{
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    } | null> | null;
    nextToken: string | null;
  } | null;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  } | null;
  poilayers: {
    __typename: "PoiLayer";
    id: string;
    name: string | null;
    color: string | null;
    data: string | null;
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    poi: {
      __typename: "ModelPoiConnection";
      nextToken: string | null;
    } | null;
    imports: {
      __typename: "ModelImportsConnection";
      nextToken: string | null;
    } | null;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    status: number | null;
  } | null;
  name: string;
  users: Array<string | null> | null;
  info: string | null;
  poiTypes: Array<string | null> | null;
};

export type OnCreateExportsSubscription = {
  __typename: "Exports";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  data: string | null;
  fileuriCSV: string | null;
  fileuriXLSX: string | null;
};

export type OnUpdateExportsSubscription = {
  __typename: "Exports";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  data: string | null;
  fileuriCSV: string | null;
  fileuriXLSX: string | null;
};

export type OnDeleteExportsSubscription = {
  __typename: "Exports";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  data: string | null;
  fileuriCSV: string | null;
  fileuriXLSX: string | null;
};

export type OnCreateFilesSubscription = {
  __typename: "Files";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  name: string | null;
  type: string | null;
  parent: string;
  s3path: string | null;
};

export type OnUpdateFilesSubscription = {
  __typename: "Files";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  name: string | null;
  type: string | null;
  parent: string;
  s3path: string | null;
};

export type OnDeleteFilesSubscription = {
  __typename: "Files";
  id: string;
  date: string;
  organizationID: string;
  owner: string | null;
  name: string | null;
  type: string | null;
  parent: string;
  s3path: string | null;
};

export type OnCreatePoiMaintenancesSubscription = {
  __typename: "PoiMaintenances";
  id: string;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  };
  type: number;
  description: string | null;
  info: string | null;
  user_create: string;
  date_create: string;
  user_assigned: string;
  date_assigned: string;
  maintenanceactions: {
    __typename: "ModelPoiMaintenancesActionsConnection";
    items: Array<{
      __typename: "PoiMaintenancesActions";
      id: string;
      type: number;
      status: number;
      description: string | null;
      info: string | null;
      user: string;
      date: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type OnUpdatePoiMaintenancesSubscription = {
  __typename: "PoiMaintenances";
  id: string;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  };
  type: number;
  description: string | null;
  info: string | null;
  user_create: string;
  date_create: string;
  user_assigned: string;
  date_assigned: string;
  maintenanceactions: {
    __typename: "ModelPoiMaintenancesActionsConnection";
    items: Array<{
      __typename: "PoiMaintenancesActions";
      id: string;
      type: number;
      status: number;
      description: string | null;
      info: string | null;
      user: string;
      date: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type OnDeletePoiMaintenancesSubscription = {
  __typename: "PoiMaintenances";
  id: string;
  poi: {
    __typename: "Poi";
    id: string;
    type: {
      __typename: "PoiType";
      id: string;
      name: string | null;
      status: number | null;
      structure: string | null;
      icon: string | null;
      infowindow: string | null;
    };
    layer: {
      __typename: "PoiLayer";
      id: string;
      name: string | null;
      color: string | null;
      data: string | null;
      owner: string;
      organizationID: string;
      status: number | null;
    };
    city: {
      __typename: "Cities";
      id: string;
      organizationID: string;
      name: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      area: string | null;
      info: string | null;
    };
    position_lat: number;
    position_lng: number;
    position_flr: number;
    owner: string;
    organization: {
      __typename: "Organizations";
      id: string;
      name: string;
      users: Array<string | null> | null;
      info: string | null;
      poiTypes: Array<string | null> | null;
    };
    organizationID: string;
    createdAt: string | null;
    data: string | null;
    status: number | null;
    files: Array<string | null> | null;
    icon: string | null;
    shape: number;
    maintenances: {
      __typename: "ModelPoiMaintenancesConnection";
      nextToken: string | null;
    } | null;
  };
  type: number;
  description: string | null;
  info: string | null;
  user_create: string;
  date_create: string;
  user_assigned: string;
  date_assigned: string;
  maintenanceactions: {
    __typename: "ModelPoiMaintenancesActionsConnection";
    items: Array<{
      __typename: "PoiMaintenancesActions";
      id: string;
      type: number;
      status: number;
      description: string | null;
      info: string | null;
      user: string;
      date: string;
    } | null> | null;
    nextToken: string | null;
  } | null;
};

export type OnCreatePoiMaintenancesActionsSubscription = {
  __typename: "PoiMaintenancesActions";
  id: string;
  type: number;
  status: number;
  maintenance: {
    __typename: "PoiMaintenances";
    id: string;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    };
    type: number;
    description: string | null;
    info: string | null;
    user_create: string;
    date_create: string;
    user_assigned: string;
    date_assigned: string;
    maintenanceactions: {
      __typename: "ModelPoiMaintenancesActionsConnection";
      nextToken: string | null;
    } | null;
  } | null;
  description: string | null;
  info: string | null;
  user: string;
  date: string;
};

export type OnUpdatePoiMaintenancesActionsSubscription = {
  __typename: "PoiMaintenancesActions";
  id: string;
  type: number;
  status: number;
  maintenance: {
    __typename: "PoiMaintenances";
    id: string;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    };
    type: number;
    description: string | null;
    info: string | null;
    user_create: string;
    date_create: string;
    user_assigned: string;
    date_assigned: string;
    maintenanceactions: {
      __typename: "ModelPoiMaintenancesActionsConnection";
      nextToken: string | null;
    } | null;
  } | null;
  description: string | null;
  info: string | null;
  user: string;
  date: string;
};

export type OnDeletePoiMaintenancesActionsSubscription = {
  __typename: "PoiMaintenancesActions";
  id: string;
  type: number;
  status: number;
  maintenance: {
    __typename: "PoiMaintenances";
    id: string;
    poi: {
      __typename: "Poi";
      id: string;
      position_lat: number;
      position_lng: number;
      position_flr: number;
      owner: string;
      organizationID: string;
      createdAt: string | null;
      data: string | null;
      status: number | null;
      files: Array<string | null> | null;
      icon: string | null;
      shape: number;
    };
    type: number;
    description: string | null;
    info: string | null;
    user_create: string;
    date_create: string;
    user_assigned: string;
    date_assigned: string;
    maintenanceactions: {
      __typename: "ModelPoiMaintenancesActionsConnection";
      nextToken: string | null;
    } | null;
  } | null;
  description: string | null;
  info: string | null;
  user: string;
  date: string;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async CreatePoi(
    input: CreatePoiInput,
    condition?: ModelPoiConditionInput
  ): Promise<CreatePoiMutation> {
    const statement = `mutation CreatePoi($input: CreatePoiInput!, $condition: ModelPoiConditionInput) {
        createPoi(input: $input, condition: $condition) {
          __typename
          id
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          position_lat
          position_lng
          position_flr
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          createdAt
          data
          status
          files
          icon
          shape
          maintenances {
            __typename
            items {
              __typename
              id
              type
              description
              info
              user_create
              date_create
              user_assigned
              date_assigned
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePoiMutation>response.data.createPoi;
  }
  async UpdatePoi(
    input: UpdatePoiInput,
    condition?: ModelPoiConditionInput
  ): Promise<UpdatePoiMutation> {
    const statement = `mutation UpdatePoi($input: UpdatePoiInput!, $condition: ModelPoiConditionInput) {
        updatePoi(input: $input, condition: $condition) {
          __typename
          id
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          position_lat
          position_lng
          position_flr
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          createdAt
          data
          status
          files
          icon
          shape
          maintenances {
            __typename
            items {
              __typename
              id
              type
              description
              info
              user_create
              date_create
              user_assigned
              date_assigned
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePoiMutation>response.data.updatePoi;
  }
  async DeletePoi(
    input: DeletePoiInput,
    condition?: ModelPoiConditionInput
  ): Promise<DeletePoiMutation> {
    const statement = `mutation DeletePoi($input: DeletePoiInput!, $condition: ModelPoiConditionInput) {
        deletePoi(input: $input, condition: $condition) {
          __typename
          id
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          position_lat
          position_lng
          position_flr
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          createdAt
          data
          status
          files
          icon
          shape
          maintenances {
            __typename
            items {
              __typename
              id
              type
              description
              info
              user_create
              date_create
              user_assigned
              date_assigned
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePoiMutation>response.data.deletePoi;
  }
  async CreatePoiLayer(
    input: CreatePoiLayerInput,
    condition?: ModelPoiLayerConditionInput
  ): Promise<CreatePoiLayerMutation> {
    const statement = `mutation CreatePoiLayer($input: CreatePoiLayerInput!, $condition: ModelPoiLayerConditionInput) {
        createPoiLayer(input: $input, condition: $condition) {
          __typename
          id
          name
          color
          data
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          status
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePoiLayerMutation>response.data.createPoiLayer;
  }
  async UpdatePoiLayer(
    input: UpdatePoiLayerInput,
    condition?: ModelPoiLayerConditionInput
  ): Promise<UpdatePoiLayerMutation> {
    const statement = `mutation UpdatePoiLayer($input: UpdatePoiLayerInput!, $condition: ModelPoiLayerConditionInput) {
        updatePoiLayer(input: $input, condition: $condition) {
          __typename
          id
          name
          color
          data
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          status
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePoiLayerMutation>response.data.updatePoiLayer;
  }
  async DeletePoiLayer(
    input: DeletePoiLayerInput,
    condition?: ModelPoiLayerConditionInput
  ): Promise<DeletePoiLayerMutation> {
    const statement = `mutation DeletePoiLayer($input: DeletePoiLayerInput!, $condition: ModelPoiLayerConditionInput) {
        deletePoiLayer(input: $input, condition: $condition) {
          __typename
          id
          name
          color
          data
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          status
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePoiLayerMutation>response.data.deletePoiLayer;
  }
  async CreatePoiType(
    input: CreatePoiTypeInput,
    condition?: ModelPoiTypeConditionInput
  ): Promise<CreatePoiTypeMutation> {
    const statement = `mutation CreatePoiType($input: CreatePoiTypeInput!, $condition: ModelPoiTypeConditionInput) {
        createPoiType(input: $input, condition: $condition) {
          __typename
          id
          name
          status
          structure
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          icon
          infowindow
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePoiTypeMutation>response.data.createPoiType;
  }
  async UpdatePoiType(
    input: UpdatePoiTypeInput,
    condition?: ModelPoiTypeConditionInput
  ): Promise<UpdatePoiTypeMutation> {
    const statement = `mutation UpdatePoiType($input: UpdatePoiTypeInput!, $condition: ModelPoiTypeConditionInput) {
        updatePoiType(input: $input, condition: $condition) {
          __typename
          id
          name
          status
          structure
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          icon
          infowindow
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePoiTypeMutation>response.data.updatePoiType;
  }
  async DeletePoiType(
    input: DeletePoiTypeInput,
    condition?: ModelPoiTypeConditionInput
  ): Promise<DeletePoiTypeMutation> {
    const statement = `mutation DeletePoiType($input: DeletePoiTypeInput!, $condition: ModelPoiTypeConditionInput) {
        deletePoiType(input: $input, condition: $condition) {
          __typename
          id
          name
          status
          structure
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          icon
          infowindow
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePoiTypeMutation>response.data.deletePoiType;
  }
  async CreateCities(
    input: CreateCitiesInput,
    condition?: ModelCitiesConditionInput
  ): Promise<CreateCitiesMutation> {
    const statement = `mutation CreateCities($input: CreateCitiesInput!, $condition: ModelCitiesConditionInput) {
        createCities(input: $input, condition: $condition) {
          __typename
          id
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          layers {
            __typename
            items {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          name
          position_lat
          position_lng
          position_flr
          area
          info
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateCitiesMutation>response.data.createCities;
  }
  async UpdateCities(
    input: UpdateCitiesInput,
    condition?: ModelCitiesConditionInput
  ): Promise<UpdateCitiesMutation> {
    const statement = `mutation UpdateCities($input: UpdateCitiesInput!, $condition: ModelCitiesConditionInput) {
        updateCities(input: $input, condition: $condition) {
          __typename
          id
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          layers {
            __typename
            items {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          name
          position_lat
          position_lng
          position_flr
          area
          info
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateCitiesMutation>response.data.updateCities;
  }
  async DeleteCities(
    input: DeleteCitiesInput,
    condition?: ModelCitiesConditionInput
  ): Promise<DeleteCitiesMutation> {
    const statement = `mutation DeleteCities($input: DeleteCitiesInput!, $condition: ModelCitiesConditionInput) {
        deleteCities(input: $input, condition: $condition) {
          __typename
          id
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          layers {
            __typename
            items {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          name
          position_lat
          position_lng
          position_flr
          area
          info
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCitiesMutation>response.data.deleteCities;
  }
  async CreateImports(
    input: CreateImportsInput,
    condition?: ModelImportsConditionInput
  ): Promise<CreateImportsMutation> {
    const statement = `mutation CreateImports($input: CreateImportsInput!, $condition: ModelImportsConditionInput) {
        createImports(input: $input, condition: $condition) {
          __typename
          id
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          date
          owner
          data
          schema
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateImportsMutation>response.data.createImports;
  }
  async UpdateImports(
    input: UpdateImportsInput,
    condition?: ModelImportsConditionInput
  ): Promise<UpdateImportsMutation> {
    const statement = `mutation UpdateImports($input: UpdateImportsInput!, $condition: ModelImportsConditionInput) {
        updateImports(input: $input, condition: $condition) {
          __typename
          id
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          date
          owner
          data
          schema
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateImportsMutation>response.data.updateImports;
  }
  async DeleteImports(
    input: DeleteImportsInput,
    condition?: ModelImportsConditionInput
  ): Promise<DeleteImportsMutation> {
    const statement = `mutation DeleteImports($input: DeleteImportsInput!, $condition: ModelImportsConditionInput) {
        deleteImports(input: $input, condition: $condition) {
          __typename
          id
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          date
          owner
          data
          schema
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteImportsMutation>response.data.deleteImports;
  }
  async CreateOrganizations(
    input: CreateOrganizationsInput,
    condition?: ModelOrganizationsConditionInput
  ): Promise<CreateOrganizationsMutation> {
    const statement = `mutation CreateOrganizations($input: CreateOrganizationsInput!, $condition: ModelOrganizationsConditionInput) {
        createOrganizations(input: $input, condition: $condition) {
          __typename
          id
          cities {
            __typename
            items {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            nextToken
          }
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          poilayers {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          name
          users
          info
          poiTypes
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateOrganizationsMutation>response.data.createOrganizations;
  }
  async UpdateOrganizations(
    input: UpdateOrganizationsInput,
    condition?: ModelOrganizationsConditionInput
  ): Promise<UpdateOrganizationsMutation> {
    const statement = `mutation UpdateOrganizations($input: UpdateOrganizationsInput!, $condition: ModelOrganizationsConditionInput) {
        updateOrganizations(input: $input, condition: $condition) {
          __typename
          id
          cities {
            __typename
            items {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            nextToken
          }
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          poilayers {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          name
          users
          info
          poiTypes
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateOrganizationsMutation>response.data.updateOrganizations;
  }
  async DeleteOrganizations(
    input: DeleteOrganizationsInput,
    condition?: ModelOrganizationsConditionInput
  ): Promise<DeleteOrganizationsMutation> {
    const statement = `mutation DeleteOrganizations($input: DeleteOrganizationsInput!, $condition: ModelOrganizationsConditionInput) {
        deleteOrganizations(input: $input, condition: $condition) {
          __typename
          id
          cities {
            __typename
            items {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            nextToken
          }
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          poilayers {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          name
          users
          info
          poiTypes
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteOrganizationsMutation>response.data.deleteOrganizations;
  }
  async CreateExports(
    input: CreateExportsInput,
    condition?: ModelExportsConditionInput
  ): Promise<CreateExportsMutation> {
    const statement = `mutation CreateExports($input: CreateExportsInput!, $condition: ModelExportsConditionInput) {
        createExports(input: $input, condition: $condition) {
          __typename
          id
          date
          organizationID
          owner
          data
          fileuriCSV
          fileuriXLSX
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateExportsMutation>response.data.createExports;
  }
  async UpdateExports(
    input: UpdateExportsInput,
    condition?: ModelExportsConditionInput
  ): Promise<UpdateExportsMutation> {
    const statement = `mutation UpdateExports($input: UpdateExportsInput!, $condition: ModelExportsConditionInput) {
        updateExports(input: $input, condition: $condition) {
          __typename
          id
          date
          organizationID
          owner
          data
          fileuriCSV
          fileuriXLSX
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateExportsMutation>response.data.updateExports;
  }
  async DeleteExports(
    input: DeleteExportsInput,
    condition?: ModelExportsConditionInput
  ): Promise<DeleteExportsMutation> {
    const statement = `mutation DeleteExports($input: DeleteExportsInput!, $condition: ModelExportsConditionInput) {
        deleteExports(input: $input, condition: $condition) {
          __typename
          id
          date
          organizationID
          owner
          data
          fileuriCSV
          fileuriXLSX
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteExportsMutation>response.data.deleteExports;
  }
  async CreateFiles(
    input: CreateFilesInput,
    condition?: ModelFilesConditionInput
  ): Promise<CreateFilesMutation> {
    const statement = `mutation CreateFiles($input: CreateFilesInput!, $condition: ModelFilesConditionInput) {
        createFiles(input: $input, condition: $condition) {
          __typename
          id
          date
          organizationID
          owner
          name
          type
          parent
          s3path
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateFilesMutation>response.data.createFiles;
  }
  async UpdateFiles(
    input: UpdateFilesInput,
    condition?: ModelFilesConditionInput
  ): Promise<UpdateFilesMutation> {
    const statement = `mutation UpdateFiles($input: UpdateFilesInput!, $condition: ModelFilesConditionInput) {
        updateFiles(input: $input, condition: $condition) {
          __typename
          id
          date
          organizationID
          owner
          name
          type
          parent
          s3path
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateFilesMutation>response.data.updateFiles;
  }
  async DeleteFiles(
    input: DeleteFilesInput,
    condition?: ModelFilesConditionInput
  ): Promise<DeleteFilesMutation> {
    const statement = `mutation DeleteFiles($input: DeleteFilesInput!, $condition: ModelFilesConditionInput) {
        deleteFiles(input: $input, condition: $condition) {
          __typename
          id
          date
          organizationID
          owner
          name
          type
          parent
          s3path
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteFilesMutation>response.data.deleteFiles;
  }
  async CreatePoiMaintenances(
    input: CreatePoiMaintenancesInput,
    condition?: ModelPoiMaintenancesConditionInput
  ): Promise<CreatePoiMaintenancesMutation> {
    const statement = `mutation CreatePoiMaintenances($input: CreatePoiMaintenancesInput!, $condition: ModelPoiMaintenancesConditionInput) {
        createPoiMaintenances(input: $input, condition: $condition) {
          __typename
          id
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          type
          description
          info
          user_create
          date_create
          user_assigned
          date_assigned
          maintenanceactions {
            __typename
            items {
              __typename
              id
              type
              status
              description
              info
              user
              date
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePoiMaintenancesMutation>response.data.createPoiMaintenances;
  }
  async UpdatePoiMaintenances(
    input: UpdatePoiMaintenancesInput,
    condition?: ModelPoiMaintenancesConditionInput
  ): Promise<UpdatePoiMaintenancesMutation> {
    const statement = `mutation UpdatePoiMaintenances($input: UpdatePoiMaintenancesInput!, $condition: ModelPoiMaintenancesConditionInput) {
        updatePoiMaintenances(input: $input, condition: $condition) {
          __typename
          id
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          type
          description
          info
          user_create
          date_create
          user_assigned
          date_assigned
          maintenanceactions {
            __typename
            items {
              __typename
              id
              type
              status
              description
              info
              user
              date
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePoiMaintenancesMutation>response.data.updatePoiMaintenances;
  }
  async DeletePoiMaintenances(
    input: DeletePoiMaintenancesInput,
    condition?: ModelPoiMaintenancesConditionInput
  ): Promise<DeletePoiMaintenancesMutation> {
    const statement = `mutation DeletePoiMaintenances($input: DeletePoiMaintenancesInput!, $condition: ModelPoiMaintenancesConditionInput) {
        deletePoiMaintenances(input: $input, condition: $condition) {
          __typename
          id
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          type
          description
          info
          user_create
          date_create
          user_assigned
          date_assigned
          maintenanceactions {
            __typename
            items {
              __typename
              id
              type
              status
              description
              info
              user
              date
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePoiMaintenancesMutation>response.data.deletePoiMaintenances;
  }
  async CreatePoiMaintenancesActions(
    input: CreatePoiMaintenancesActionsInput,
    condition?: ModelPoiMaintenancesActionsConditionInput
  ): Promise<CreatePoiMaintenancesActionsMutation> {
    const statement = `mutation CreatePoiMaintenancesActions($input: CreatePoiMaintenancesActionsInput!, $condition: ModelPoiMaintenancesActionsConditionInput) {
        createPoiMaintenancesActions(input: $input, condition: $condition) {
          __typename
          id
          type
          status
          maintenance {
            __typename
            id
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            type
            description
            info
            user_create
            date_create
            user_assigned
            date_assigned
            maintenanceactions {
              __typename
              nextToken
            }
          }
          description
          info
          user
          date
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePoiMaintenancesActionsMutation>(
      response.data.createPoiMaintenancesActions
    );
  }
  async UpdatePoiMaintenancesActions(
    input: UpdatePoiMaintenancesActionsInput,
    condition?: ModelPoiMaintenancesActionsConditionInput
  ): Promise<UpdatePoiMaintenancesActionsMutation> {
    const statement = `mutation UpdatePoiMaintenancesActions($input: UpdatePoiMaintenancesActionsInput!, $condition: ModelPoiMaintenancesActionsConditionInput) {
        updatePoiMaintenancesActions(input: $input, condition: $condition) {
          __typename
          id
          type
          status
          maintenance {
            __typename
            id
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            type
            description
            info
            user_create
            date_create
            user_assigned
            date_assigned
            maintenanceactions {
              __typename
              nextToken
            }
          }
          description
          info
          user
          date
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePoiMaintenancesActionsMutation>(
      response.data.updatePoiMaintenancesActions
    );
  }
  async DeletePoiMaintenancesActions(
    input: DeletePoiMaintenancesActionsInput,
    condition?: ModelPoiMaintenancesActionsConditionInput
  ): Promise<DeletePoiMaintenancesActionsMutation> {
    const statement = `mutation DeletePoiMaintenancesActions($input: DeletePoiMaintenancesActionsInput!, $condition: ModelPoiMaintenancesActionsConditionInput) {
        deletePoiMaintenancesActions(input: $input, condition: $condition) {
          __typename
          id
          type
          status
          maintenance {
            __typename
            id
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            type
            description
            info
            user_create
            date_create
            user_assigned
            date_assigned
            maintenanceactions {
              __typename
              nextToken
            }
          }
          description
          info
          user
          date
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePoiMaintenancesActionsMutation>(
      response.data.deletePoiMaintenancesActions
    );
  }
  async GetPoi(id: string): Promise<GetPoiQuery> {
    const statement = `query GetPoi($id: ID!) {
        getPoi(id: $id) {
          __typename
          id
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          position_lat
          position_lng
          position_flr
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          createdAt
          data
          status
          files
          icon
          shape
          maintenances {
            __typename
            items {
              __typename
              id
              type
              description
              info
              user_create
              date_create
              user_assigned
              date_assigned
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPoiQuery>response.data.getPoi;
  }
  async ListPois(
    filter?: ModelPoiFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPoisQuery> {
    const statement = `query ListPois($filter: ModelPoiFilterInput, $limit: Int, $nextToken: String) {
        listPois(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPoisQuery>response.data.listPois;
  }
  async GetPoiLayer(id: string): Promise<GetPoiLayerQuery> {
    const statement = `query GetPoiLayer($id: ID!) {
        getPoiLayer(id: $id) {
          __typename
          id
          name
          color
          data
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          status
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPoiLayerQuery>response.data.getPoiLayer;
  }
  async ListPoiLayers(
    filter?: ModelPoiLayerFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPoiLayersQuery> {
    const statement = `query ListPoiLayers($filter: ModelPoiLayerFilterInput, $limit: Int, $nextToken: String) {
        listPoiLayers(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPoiLayersQuery>response.data.listPoiLayers;
  }
  async GetPoiType(id: string): Promise<GetPoiTypeQuery> {
    const statement = `query GetPoiType($id: ID!) {
        getPoiType(id: $id) {
          __typename
          id
          name
          status
          structure
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          icon
          infowindow
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPoiTypeQuery>response.data.getPoiType;
  }
  async ListPoiTypes(
    filter?: ModelPoiTypeFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPoiTypesQuery> {
    const statement = `query ListPoiTypes($filter: ModelPoiTypeFilterInput, $limit: Int, $nextToken: String) {
        listPoiTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPoiTypesQuery>response.data.listPoiTypes;
  }
  async GetCities(id: string): Promise<GetCitiesQuery> {
    const statement = `query GetCities($id: ID!) {
        getCities(id: $id) {
          __typename
          id
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          layers {
            __typename
            items {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          name
          position_lat
          position_lng
          position_flr
          area
          info
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetCitiesQuery>response.data.getCities;
  }
  async ListCitiess(
    filter?: ModelCitiesFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListCitiessQuery> {
    const statement = `query ListCitiess($filter: ModelCitiesFilterInput, $limit: Int, $nextToken: String) {
        listCitiess(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListCitiessQuery>response.data.listCitiess;
  }
  async GetImports(id: string): Promise<GetImportsQuery> {
    const statement = `query GetImports($id: ID!) {
        getImports(id: $id) {
          __typename
          id
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          date
          owner
          data
          schema
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetImportsQuery>response.data.getImports;
  }
  async ListImportss(
    filter?: ModelImportsFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListImportssQuery> {
    const statement = `query ListImportss($filter: ModelImportsFilterInput, $limit: Int, $nextToken: String) {
        listImportss(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            date
            owner
            data
            schema
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListImportssQuery>response.data.listImportss;
  }
  async GetOrganizations(id: string): Promise<GetOrganizationsQuery> {
    const statement = `query GetOrganizations($id: ID!) {
        getOrganizations(id: $id) {
          __typename
          id
          cities {
            __typename
            items {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            nextToken
          }
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          poilayers {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          name
          users
          info
          poiTypes
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetOrganizationsQuery>response.data.getOrganizations;
  }
  async ListOrganizationss(
    filter?: ModelOrganizationsFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListOrganizationssQuery> {
    const statement = `query ListOrganizationss($filter: ModelOrganizationsFilterInput, $limit: Int, $nextToken: String) {
        listOrganizationss(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListOrganizationssQuery>response.data.listOrganizationss;
  }
  async GetExports(id: string): Promise<GetExportsQuery> {
    const statement = `query GetExports($id: ID!) {
        getExports(id: $id) {
          __typename
          id
          date
          organizationID
          owner
          data
          fileuriCSV
          fileuriXLSX
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetExportsQuery>response.data.getExports;
  }
  async ListExportss(
    filter?: ModelExportsFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListExportssQuery> {
    const statement = `query ListExportss($filter: ModelExportsFilterInput, $limit: Int, $nextToken: String) {
        listExportss(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            date
            organizationID
            owner
            data
            fileuriCSV
            fileuriXLSX
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListExportssQuery>response.data.listExportss;
  }
  async GetFiles(id: string): Promise<GetFilesQuery> {
    const statement = `query GetFiles($id: ID!) {
        getFiles(id: $id) {
          __typename
          id
          date
          organizationID
          owner
          name
          type
          parent
          s3path
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetFilesQuery>response.data.getFiles;
  }
  async ListFiless(
    filter?: ModelFilesFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListFilessQuery> {
    const statement = `query ListFiless($filter: ModelFilesFilterInput, $limit: Int, $nextToken: String) {
        listFiless(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            date
            organizationID
            owner
            name
            type
            parent
            s3path
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListFilessQuery>response.data.listFiless;
  }
  async GetPoiMaintenances(id: string): Promise<GetPoiMaintenancesQuery> {
    const statement = `query GetPoiMaintenances($id: ID!) {
        getPoiMaintenances(id: $id) {
          __typename
          id
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          type
          description
          info
          user_create
          date_create
          user_assigned
          date_assigned
          maintenanceactions {
            __typename
            items {
              __typename
              id
              type
              status
              description
              info
              user
              date
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPoiMaintenancesQuery>response.data.getPoiMaintenances;
  }
  async ListPoiMaintenancess(
    filter?: ModelPoiMaintenancesFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPoiMaintenancessQuery> {
    const statement = `query ListPoiMaintenancess($filter: ModelPoiMaintenancesFilterInput, $limit: Int, $nextToken: String) {
        listPoiMaintenancess(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            type
            description
            info
            user_create
            date_create
            user_assigned
            date_assigned
            maintenanceactions {
              __typename
              nextToken
            }
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPoiMaintenancessQuery>response.data.listPoiMaintenancess;
  }
  async GetPoiMaintenancesActions(
    id: string
  ): Promise<GetPoiMaintenancesActionsQuery> {
    const statement = `query GetPoiMaintenancesActions($id: ID!) {
        getPoiMaintenancesActions(id: $id) {
          __typename
          id
          type
          status
          maintenance {
            __typename
            id
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            type
            description
            info
            user_create
            date_create
            user_assigned
            date_assigned
            maintenanceactions {
              __typename
              nextToken
            }
          }
          description
          info
          user
          date
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPoiMaintenancesActionsQuery>(
      response.data.getPoiMaintenancesActions
    );
  }
  async ListPoiMaintenancesActionss(
    filter?: ModelPoiMaintenancesActionsFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPoiMaintenancesActionssQuery> {
    const statement = `query ListPoiMaintenancesActionss($filter: ModelPoiMaintenancesActionsFilterInput, $limit: Int, $nextToken: String) {
        listPoiMaintenancesActionss(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            type
            status
            maintenance {
              __typename
              id
              type
              description
              info
              user_create
              date_create
              user_assigned
              date_assigned
            }
            description
            info
            user
            date
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPoiMaintenancesActionssQuery>(
      response.data.listPoiMaintenancesActionss
    );
  }
  async SearchPois(
    filter?: SearchablePoiFilterInput,
    sort?: SearchablePoiSortInput,
    limit?: number,
    nextToken?: string
  ): Promise<SearchPoisQuery> {
    const statement = `query SearchPois($filter: SearchablePoiFilterInput, $sort: SearchablePoiSortInput, $limit: Int, $nextToken: String) {
        searchPois(filter: $filter, sort: $sort, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          nextToken
          total
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (sort) {
      gqlAPIServiceArguments.sort = sort;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SearchPoisQuery>response.data.searchPois;
  }
  async SearchCitiess(
    filter?: SearchableCitiesFilterInput,
    sort?: SearchableCitiesSortInput,
    limit?: number,
    nextToken?: string
  ): Promise<SearchCitiessQuery> {
    const statement = `query SearchCitiess($filter: SearchableCitiesFilterInput, $sort: SearchableCitiesSortInput, $limit: Int, $nextToken: String) {
        searchCitiess(filter: $filter, sort: $sort, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          nextToken
          total
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (sort) {
      gqlAPIServiceArguments.sort = sort;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SearchCitiessQuery>response.data.searchCitiess;
  }
  async SearchFiless(
    filter?: SearchableFilesFilterInput,
    sort?: SearchableFilesSortInput,
    limit?: number,
    nextToken?: string
  ): Promise<SearchFilessQuery> {
    const statement = `query SearchFiless($filter: SearchableFilesFilterInput, $sort: SearchableFilesSortInput, $limit: Int, $nextToken: String) {
        searchFiless(filter: $filter, sort: $sort, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            date
            organizationID
            owner
            name
            type
            parent
            s3path
          }
          nextToken
          total
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (sort) {
      gqlAPIServiceArguments.sort = sort;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SearchFilessQuery>response.data.searchFiless;
  }
  OnCreatePoiListener: Observable<OnCreatePoiSubscription> = API.graphql(
    graphqlOperation(
      `subscription OnCreatePoi {
        onCreatePoi {
          __typename
          id
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          position_lat
          position_lng
          position_flr
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          createdAt
          data
          status
          files
          icon
          shape
          maintenances {
            __typename
            items {
              __typename
              id
              type
              description
              info
              user_create
              date_create
              user_assigned
              date_assigned
            }
            nextToken
          }
        }
      }`
    )
  ) as Observable<OnCreatePoiSubscription>;

  OnUpdatePoiListener: Observable<OnUpdatePoiSubscription> = API.graphql(
    graphqlOperation(
      `subscription OnUpdatePoi {
        onUpdatePoi {
          __typename
          id
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          position_lat
          position_lng
          position_flr
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          createdAt
          data
          status
          files
          icon
          shape
          maintenances {
            __typename
            items {
              __typename
              id
              type
              description
              info
              user_create
              date_create
              user_assigned
              date_assigned
            }
            nextToken
          }
        }
      }`
    )
  ) as Observable<OnUpdatePoiSubscription>;

  OnDeletePoiListener: Observable<OnDeletePoiSubscription> = API.graphql(
    graphqlOperation(
      `subscription OnDeletePoi {
        onDeletePoi {
          __typename
          id
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          position_lat
          position_lng
          position_flr
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          createdAt
          data
          status
          files
          icon
          shape
          maintenances {
            __typename
            items {
              __typename
              id
              type
              description
              info
              user_create
              date_create
              user_assigned
              date_assigned
            }
            nextToken
          }
        }
      }`
    )
  ) as Observable<OnDeletePoiSubscription>;

  OnCreatePoiLayerListener: Observable<
    OnCreatePoiLayerSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreatePoiLayer {
        onCreatePoiLayer {
          __typename
          id
          name
          color
          data
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          status
        }
      }`
    )
  ) as Observable<OnCreatePoiLayerSubscription>;

  OnUpdatePoiLayerListener: Observable<
    OnUpdatePoiLayerSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdatePoiLayer {
        onUpdatePoiLayer {
          __typename
          id
          name
          color
          data
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          status
        }
      }`
    )
  ) as Observable<OnUpdatePoiLayerSubscription>;

  OnDeletePoiLayerListener: Observable<
    OnDeletePoiLayerSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeletePoiLayer {
        onDeletePoiLayer {
          __typename
          id
          name
          color
          data
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          owner
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          status
        }
      }`
    )
  ) as Observable<OnDeletePoiLayerSubscription>;

  OnCreatePoiTypeListener: Observable<
    OnCreatePoiTypeSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreatePoiType {
        onCreatePoiType {
          __typename
          id
          name
          status
          structure
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          icon
          infowindow
        }
      }`
    )
  ) as Observable<OnCreatePoiTypeSubscription>;

  OnUpdatePoiTypeListener: Observable<
    OnUpdatePoiTypeSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdatePoiType {
        onUpdatePoiType {
          __typename
          id
          name
          status
          structure
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          icon
          infowindow
        }
      }`
    )
  ) as Observable<OnUpdatePoiTypeSubscription>;

  OnDeletePoiTypeListener: Observable<
    OnDeletePoiTypeSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeletePoiType {
        onDeletePoiType {
          __typename
          id
          name
          status
          structure
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          icon
          infowindow
        }
      }`
    )
  ) as Observable<OnDeletePoiTypeSubscription>;

  OnCreateCitiesListener: Observable<OnCreateCitiesSubscription> = API.graphql(
    graphqlOperation(
      `subscription OnCreateCities {
        onCreateCities {
          __typename
          id
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          layers {
            __typename
            items {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          name
          position_lat
          position_lng
          position_flr
          area
          info
        }
      }`
    )
  ) as Observable<OnCreateCitiesSubscription>;

  OnUpdateCitiesListener: Observable<OnUpdateCitiesSubscription> = API.graphql(
    graphqlOperation(
      `subscription OnUpdateCities {
        onUpdateCities {
          __typename
          id
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          layers {
            __typename
            items {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          name
          position_lat
          position_lng
          position_flr
          area
          info
        }
      }`
    )
  ) as Observable<OnUpdateCitiesSubscription>;

  OnDeleteCitiesListener: Observable<OnDeleteCitiesSubscription> = API.graphql(
    graphqlOperation(
      `subscription OnDeleteCities {
        onDeleteCities {
          __typename
          id
          poi {
            __typename
            items {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            nextToken
          }
          layers {
            __typename
            items {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            nextToken
          }
          imports {
            __typename
            items {
              __typename
              id
              date
              owner
              data
              schema
            }
            nextToken
          }
          organization {
            __typename
            id
            cities {
              __typename
              nextToken
            }
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            poilayers {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            name
            users
            info
            poiTypes
          }
          organizationID
          name
          position_lat
          position_lng
          position_flr
          area
          info
        }
      }`
    )
  ) as Observable<OnDeleteCitiesSubscription>;

  OnCreateImportsListener: Observable<
    OnCreateImportsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateImports {
        onCreateImports {
          __typename
          id
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          date
          owner
          data
          schema
        }
      }`
    )
  ) as Observable<OnCreateImportsSubscription>;

  OnUpdateImportsListener: Observable<
    OnUpdateImportsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateImports {
        onUpdateImports {
          __typename
          id
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          date
          owner
          data
          schema
        }
      }`
    )
  ) as Observable<OnUpdateImportsSubscription>;

  OnDeleteImportsListener: Observable<
    OnDeleteImportsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteImports {
        onDeleteImports {
          __typename
          id
          city {
            __typename
            id
            poi {
              __typename
              nextToken
            }
            layers {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            name
            position_lat
            position_lng
            position_flr
            area
            info
          }
          layer {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          type {
            __typename
            id
            name
            status
            structure
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            icon
            infowindow
          }
          date
          owner
          data
          schema
        }
      }`
    )
  ) as Observable<OnDeleteImportsSubscription>;

  OnCreateOrganizationsListener: Observable<
    OnCreateOrganizationsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateOrganizations {
        onCreateOrganizations {
          __typename
          id
          cities {
            __typename
            items {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            nextToken
          }
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          poilayers {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          name
          users
          info
          poiTypes
        }
      }`
    )
  ) as Observable<OnCreateOrganizationsSubscription>;

  OnUpdateOrganizationsListener: Observable<
    OnUpdateOrganizationsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateOrganizations {
        onUpdateOrganizations {
          __typename
          id
          cities {
            __typename
            items {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            nextToken
          }
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          poilayers {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          name
          users
          info
          poiTypes
        }
      }`
    )
  ) as Observable<OnUpdateOrganizationsSubscription>;

  OnDeleteOrganizationsListener: Observable<
    OnDeleteOrganizationsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteOrganizations {
        onDeleteOrganizations {
          __typename
          id
          cities {
            __typename
            items {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            nextToken
          }
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          poilayers {
            __typename
            id
            name
            color
            data
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            poi {
              __typename
              nextToken
            }
            imports {
              __typename
              nextToken
            }
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            status
          }
          name
          users
          info
          poiTypes
        }
      }`
    )
  ) as Observable<OnDeleteOrganizationsSubscription>;

  OnCreateExportsListener: Observable<
    OnCreateExportsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateExports {
        onCreateExports {
          __typename
          id
          date
          organizationID
          owner
          data
          fileuriCSV
          fileuriXLSX
        }
      }`
    )
  ) as Observable<OnCreateExportsSubscription>;

  OnUpdateExportsListener: Observable<
    OnUpdateExportsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateExports {
        onUpdateExports {
          __typename
          id
          date
          organizationID
          owner
          data
          fileuriCSV
          fileuriXLSX
        }
      }`
    )
  ) as Observable<OnUpdateExportsSubscription>;

  OnDeleteExportsListener: Observable<
    OnDeleteExportsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteExports {
        onDeleteExports {
          __typename
          id
          date
          organizationID
          owner
          data
          fileuriCSV
          fileuriXLSX
        }
      }`
    )
  ) as Observable<OnDeleteExportsSubscription>;

  OnCreateFilesListener: Observable<OnCreateFilesSubscription> = API.graphql(
    graphqlOperation(
      `subscription OnCreateFiles {
        onCreateFiles {
          __typename
          id
          date
          organizationID
          owner
          name
          type
          parent
          s3path
        }
      }`
    )
  ) as Observable<OnCreateFilesSubscription>;

  OnUpdateFilesListener: Observable<OnUpdateFilesSubscription> = API.graphql(
    graphqlOperation(
      `subscription OnUpdateFiles {
        onUpdateFiles {
          __typename
          id
          date
          organizationID
          owner
          name
          type
          parent
          s3path
        }
      }`
    )
  ) as Observable<OnUpdateFilesSubscription>;

  OnDeleteFilesListener: Observable<OnDeleteFilesSubscription> = API.graphql(
    graphqlOperation(
      `subscription OnDeleteFiles {
        onDeleteFiles {
          __typename
          id
          date
          organizationID
          owner
          name
          type
          parent
          s3path
        }
      }`
    )
  ) as Observable<OnDeleteFilesSubscription>;

  OnCreatePoiMaintenancesListener: Observable<
    OnCreatePoiMaintenancesSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreatePoiMaintenances {
        onCreatePoiMaintenances {
          __typename
          id
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          type
          description
          info
          user_create
          date_create
          user_assigned
          date_assigned
          maintenanceactions {
            __typename
            items {
              __typename
              id
              type
              status
              description
              info
              user
              date
            }
            nextToken
          }
        }
      }`
    )
  ) as Observable<OnCreatePoiMaintenancesSubscription>;

  OnUpdatePoiMaintenancesListener: Observable<
    OnUpdatePoiMaintenancesSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdatePoiMaintenances {
        onUpdatePoiMaintenances {
          __typename
          id
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          type
          description
          info
          user_create
          date_create
          user_assigned
          date_assigned
          maintenanceactions {
            __typename
            items {
              __typename
              id
              type
              status
              description
              info
              user
              date
            }
            nextToken
          }
        }
      }`
    )
  ) as Observable<OnUpdatePoiMaintenancesSubscription>;

  OnDeletePoiMaintenancesListener: Observable<
    OnDeletePoiMaintenancesSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeletePoiMaintenances {
        onDeletePoiMaintenances {
          __typename
          id
          poi {
            __typename
            id
            type {
              __typename
              id
              name
              status
              structure
              icon
              infowindow
            }
            layer {
              __typename
              id
              name
              color
              data
              owner
              organizationID
              status
            }
            city {
              __typename
              id
              organizationID
              name
              position_lat
              position_lng
              position_flr
              area
              info
            }
            position_lat
            position_lng
            position_flr
            owner
            organization {
              __typename
              id
              name
              users
              info
              poiTypes
            }
            organizationID
            createdAt
            data
            status
            files
            icon
            shape
            maintenances {
              __typename
              nextToken
            }
          }
          type
          description
          info
          user_create
          date_create
          user_assigned
          date_assigned
          maintenanceactions {
            __typename
            items {
              __typename
              id
              type
              status
              description
              info
              user
              date
            }
            nextToken
          }
        }
      }`
    )
  ) as Observable<OnDeletePoiMaintenancesSubscription>;

  OnCreatePoiMaintenancesActionsListener: Observable<
    OnCreatePoiMaintenancesActionsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreatePoiMaintenancesActions {
        onCreatePoiMaintenancesActions {
          __typename
          id
          type
          status
          maintenance {
            __typename
            id
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            type
            description
            info
            user_create
            date_create
            user_assigned
            date_assigned
            maintenanceactions {
              __typename
              nextToken
            }
          }
          description
          info
          user
          date
        }
      }`
    )
  ) as Observable<OnCreatePoiMaintenancesActionsSubscription>;

  OnUpdatePoiMaintenancesActionsListener: Observable<
    OnUpdatePoiMaintenancesActionsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdatePoiMaintenancesActions {
        onUpdatePoiMaintenancesActions {
          __typename
          id
          type
          status
          maintenance {
            __typename
            id
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            type
            description
            info
            user_create
            date_create
            user_assigned
            date_assigned
            maintenanceactions {
              __typename
              nextToken
            }
          }
          description
          info
          user
          date
        }
      }`
    )
  ) as Observable<OnUpdatePoiMaintenancesActionsSubscription>;

  OnDeletePoiMaintenancesActionsListener: Observable<
    OnDeletePoiMaintenancesActionsSubscription
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeletePoiMaintenancesActions {
        onDeletePoiMaintenancesActions {
          __typename
          id
          type
          status
          maintenance {
            __typename
            id
            poi {
              __typename
              id
              position_lat
              position_lng
              position_flr
              owner
              organizationID
              createdAt
              data
              status
              files
              icon
              shape
            }
            type
            description
            info
            user_create
            date_create
            user_assigned
            date_assigned
            maintenanceactions {
              __typename
              nextToken
            }
          }
          description
          info
          user
          date
        }
      }`
    )
  ) as Observable<OnDeletePoiMaintenancesActionsSubscription>;
}
